import React from 'react';

const TAG_COLORS = {
  green: { bg: '#f4f7ed', text: '#556B2F' },
  blue: { bg: '#e3f2fd', text: '#1976d2' },
  pink: { bg: '#fce4ec', text: '#c2185b' },
  orange: { bg: '#fff3e0', text: '#E65100' },
  gray: { bg: '#f5f5f5', text: '#8e8e8e' }
};

function StoryTitle({ title, tags = [], titleSize = 'medium' }) {
  return (
    <div className="story-title-section">
      <h1 className={`story-title story-title-${titleSize}`}>
        {title}
      </h1>
      {tags.length > 0 && (
        <div className="story-tags">
          {tags.map((tag) => (
            <span
              key={tag.id}
              className="story-tag"
              style={{
                backgroundColor: TAG_COLORS[tag.color]?.bg || TAG_COLORS.gray.bg,
                color: TAG_COLORS[tag.color]?.text || TAG_COLORS.gray.text
              }}
            >
              {tag.emoji} {tag.label}
            </span>
          ))}
        </div>
      )}
    </div>
  );
}

export default StoryTitle;
